import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FlexCol, SpecialInstructions, Option, SummaryModalHeader1 } from './styles';
import RadioButtonQuestion from '../../RadioButtonQuestion';
import TextOptInNumberEditor from './TextOptInNumberEditor';
import DropdownQuestion from '../../DropdownQuestion';

const JobOptions = ({
  className,
  textOptIn,
  textOptInNumber,
  windowRemoval,
  windowHaul,
  specialInstructions,
  onOptionChange,
  windowHaulCount,
  windowRemoveCount,
  totalWindowCount,
  isInstallOnly,
}) => {
  const setWindowRemoval = useCallback(v => onOptionChange('windowRemoval', v), [onOptionChange]);
  const setWindowHaulAway = useCallback(v => onOptionChange('windowHaul', v), [onOptionChange]);
  const setSpecialInstructions = useCallback(event => onOptionChange('specialInstructions', event.target.value), [onOptionChange]);
  const setTextOptIn = useCallback(v => onOptionChange('textOptIn', v), [onOptionChange]);
  const setTextOptInNumber = useCallback(v => onOptionChange('textOptInNumber', v), [onOptionChange]);
  const setWindowHaulCount = useCallback(event => onOptionChange('windowHaulCount', parseInt(event.target.id)), [onOptionChange]);
  const setWindowRemoveCount = useCallback(event => onOptionChange('windowRemoveCount', parseInt(event.target.id)), [onOptionChange]);
  const totalWindowOptions = [...Array(totalWindowCount)].map((_, idx) => (idx + 1 > 9
    ? ({ value: idx + 1, text: `${idx + 1}` })
    : ({ value: idx + 1, text: `0${idx + 1}` })));
  const isTHD = window.globalConfig.siteId === 11;

  return (
    <FlexCol className={className}>
      <SummaryModalHeader1>Share Project Details</SummaryModalHeader1>
      <RadioButtonQuestion
        name="windowRemoval"
        label="Would you like to remove any window treatments you currently have hanging?"
        options={[
          { value: true, label: 'Yes' },
          { value: false, label: 'No' },
        ]}
        value={windowRemoval}
        onChange={setWindowRemoval}
        required
      />
      {
        windowRemoval && !isInstallOnly && !isTHD &&
        <DropdownQuestion
          name="windowRemovalCount"
          label="How many window treatments would you like to remove?"
          value={windowRemoveCount}
          options={totalWindowOptions}
          onChange={setWindowRemoveCount}
          disabled={!windowRemoval}
          required={windowRemoval}
        />
      }

      <RadioButtonQuestion
        name="windowHaul"
        label="Would you like to haul away any window treatments?"
        options={[
        { value: true, label: 'Yes' },
        { value: false, label: 'No' },
      ]}
        value={windowHaul}
        onChange={setWindowHaulAway}
        required
      />
      {
        windowHaul && !isInstallOnly && !isTHD &&
        <DropdownQuestion
          name="windowRemovalCount"
          label="How many window treatments would you like to haul away?"
          value={windowHaulCount}
          options={totalWindowOptions}
          onChange={setWindowHaulCount}
          disabled={!windowHaul}
          required={windowHaul}
        />
      }
      <RadioButtonQuestion
        name="textOptIn"
        label="Would you like us to send text messages with appointment updates?"
        options={[
        { value: true, label: 'Yes' },
        { value: false, label: 'No' },
      ]}
        value={textOptIn}
        onChange={setTextOptIn}
        required
        additionalLabel={textOptIn && (
          <TextOptInNumberEditor
            number={textOptInNumber}
            onChange={setTextOptInNumber}
          />
        )}
      />
      <Option>
        <span>Do you have special instructions?</span>
        <SpecialInstructions
          id="specialInstructions"
          value={specialInstructions}
          onChange={setSpecialInstructions}
          placeholder="Please share information like gate codes or parking instructions to make the appointment go as smoothly as possible."
        />
      </Option>
    </FlexCol>
  );
};
JobOptions.propTypes = {
  textOptIn: PropTypes.bool.isRequired,
  textOptInNumber: PropTypes.string.isRequired,
  windowRemoval: PropTypes.bool.isRequired,
  windowHaul: PropTypes.bool.isRequired,
  specialInstructions: PropTypes.string.isRequired,
  onOptionChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  windowHaulCount: PropTypes.number,
  windowRemoveCount: PropTypes.number,
  totalWindowCount: PropTypes.number,
  isInstallOnly: PropTypes.bool,
};
JobOptions.defaultProps = {
  className: '',
  windowHaulCount: 0,
  windowRemoveCount: 0,
  totalWindowCount: 0,
  isInstallOnly: false,
};

export default JobOptions;
